function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as styles from './address.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var formatFullAddress = addressModel => {
  var addressLine2 = [addressModel.suburb, addressModel.state, addressModel.postcode].filter(item => item).join(' ');
  var address = [addressModel.street, addressLine2].filter(item => item).join(', ');
  return address;
};
var Address = _ref => {
  var street = _ref.street,
    suburb = _ref.suburb,
    state = _ref.state,
    postcode = _ref.postcode,
    _ref$includeStructure = _ref.includeStructuredData,
    includeStructuredData = _ref$includeStructure === void 0 ? true : _ref$includeStructure;
  var renderLine1 = () => street && ___EmotionJSX("div", _extends({
    css: styles.line1
  }, includeStructuredData ? {
    itemProp: 'streetAddress'
  } : {}, {
    title: street
  }), street);
  var renderLine2 = () => {
    if (!(suburb || state || postcode)) {
      return false;
    }
    var line2 = [];
    if (suburb) {
      line2.push(___EmotionJSX("span", _extends({
        key: "locality"
      }, includeStructuredData ? {
        itemProp: 'addressLocality'
      } : {}), suburb));
    }
    if (state) {
      line2.push(___EmotionJSX("span", _extends({
        key: "region"
      }, includeStructuredData ? {
        itemProp: 'addressRegion'
      } : {}), state));
    }
    if (postcode) {
      line2.push(___EmotionJSX("span", _extends({
        key: "postcode"
      }, includeStructuredData ? {
        itemProp: 'postalCode'
      } : {}), postcode));
    }
    var line2Spaced = line2.reduce((prev, curr, index) => {
      if (index === 0) {
        prev.push(curr);
      } else {
        prev.push(' ');
        prev.push(curr);
      }
      return prev;
    }, []);
    return ___EmotionJSX("div", {
      className: "allhomes-listing-card__address-line-2"
    }, line2Spaced);
  };
  return ___EmotionJSX("div", _extends({
    className: "allhomes-listing-card__address"
  }, includeStructuredData ? {
    itemScope: true,
    itemType: 'http://schema.org/Residence'
  } : {}), ___EmotionJSX("meta", _extends({
    content: formatFullAddress({
      street,
      state,
      suburb,
      postcode
    })
  }, includeStructuredData ? {
    itemProp: 'name'
  } : {})), ___EmotionJSX("div", _extends({
    className: "allhomes-listing-card__address-scope"
  }, includeStructuredData ? {
    itemScope: true,
    itemProp: 'address',
    itemType: 'http://schema.org/PostalAddress'
  } : {}), renderLine1(), renderLine2()));
};
export default Address;